import React, { useState } from 'react'
import {
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CButton,
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter,
} from '@coreui/react-pro'
import CommonService from 'src/service/CommonService'
import ToastComponent from 'src/components/common/TaostComponent'

const ShowPricingQuotaModelForGame = (props) => {
  const {
    pricingQuoteVisibleModal,
    setPricingQuoteVisibleModal,
    quoteRecordDetails,
    getPricingQuoteData,
  } = props
  const [adminVisibleModal, setAdminVisibleModal] = useState(false)
  const [quoteData, setQuoteData] = useState({
    tier: '',
    duration: '',
    cost: 0,
    addScoreBlock: true,
  })
  const handlePlanQuote = (amount, tier, duration, min_teams, max_teams) => {
    const additionalFee = 12
    const addScoreBlock = true
    const total = amount + (addScoreBlock ? additionalFee : 0)

    setQuoteData({
      tier,
      duration,
      cost: amount,
      addScoreBlock,
      additionalFee,
      total,
      min_teams,
      max_teams,
      recordId: quoteRecordDetails.recordId,
      gameId: quoteRecordDetails.gameId,
    })

    setAdminVisibleModal(true)
  }
  const savePricingQuotaByAdmin = () => {
    CommonService.savePricingQuotaByAdmin(quoteData)
      .then((res) => {
        ToastComponent(res?.data?.message || 'Pricing quote saved successfully', 'success')
        setAdminVisibleModal(false)
        setPricingQuoteVisibleModal(false)
        getPricingQuoteData()
      })
      .catch((error) => {
        console.error('Error saving pricing quota:', error)
        const status = error?.status
        const message = error?.message

        if (status === 409 && message) {
          ToastComponent(message, 'error') // Show backend duplicate error
        } else {
          ToastComponent('Error saving pricing quota', 'error')
        }
      })
  }
  return (
    <>
      <CModal
        visible={pricingQuoteVisibleModal}
        onClose={() => setPricingQuoteVisibleModal(false)}
        size="lg"
        scrollable
      >
        <CModalHeader>
          <strong>Quote Summary</strong>
        </CModalHeader>
        <CModalBody>
          <CTable bordered className="mt-4">
            <CTableHead color="warning">
              <CTableRow>
                <CTableHeaderCell>Team Tiers</CTableHeaderCell>
                <CTableHeaderCell>6 Months</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {[
                {
                  tier: '1–4 Teams',
                  min_teams: 1,
                  max_teams: 4,
                  six: '$300',
                },
                {
                  tier: '5–8 Teams',
                  min_teams: 5,
                  max_teams: 8,
                  six: '$420',
                },
                {
                  tier: '9–12 Teams',
                  min_teams: 9,
                  max_teams: 12,
                  six: '$540',
                },
                {
                  tier: '13–16 Teams',
                  min_teams: 13,
                  max_teams: 16,
                  six: '$660',
                },
                {
                  tier: '17–20 Teams',
                  min_teams: 17,
                  max_teams: 20,
                  six: '$780',
                },
                {
                  tier: '21+ Teams',
                  min_teams: 21,
                  max_teams: null,
                  six: '$900',
                },
              ].map((item, index) => (
                <CTableRow key={index}>
                  <CTableDataCell>{item.tier}</CTableDataCell>
                  <CTableDataCell>
                    <span
                      style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                      onClick={() =>
                        handlePlanQuote(
                          parseInt(item.six.replace('$', '')),
                          item.tier,
                          '6',
                          item.min_teams,
                          item.max_teams,
                        )
                      }
                    >
                      {item.six}
                    </span>
                  </CTableDataCell>
                </CTableRow>
              ))}
            </CTableBody>
          </CTable>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setPricingQuoteVisibleModal(false)}>
            Cancel
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal visible={adminVisibleModal} onClose={() => setAdminVisibleModal(false)}>
        <CModalHeader>
          <strong>Quote Summary</strong>
        </CModalHeader>
        <CModalBody>
          <p>
            <strong>Team Tier:</strong> {quoteData.tier}
          </p>
          <p>
            <strong>Plan Duration:</strong> {quoteData.duration}
          </p>

          {/* Checkbox for ScoreMail Block */}
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="scoremailCheckbox"
              checked={quoteData.addScoreBlock}
              onChange={(e) =>
                setQuoteData((prev) => ({
                  ...prev,
                  addScoreBlock: e.target.checked,
                  total: e.target.checked ? prev.cost + prev.additionalFee : prev.cost,
                }))
              }
            />
            <label className="form-check-label" htmlFor="scoremailCheckbox">
              Add ScoreMail Block (A$ {quoteData.additionalFee})
            </label>
          </div>

          <p>
            <strong>Cost:</strong> A$ {quoteData.cost}
            {quoteData.addScoreBlock && <> + A$ {quoteData.additionalFee}</>}
          </p>
          <p>
            <strong>Total:</strong> <strong>A$ {quoteData.total}</strong>
          </p>
        </CModalBody>
        <CModalFooter>
          <CButton
            color="primary"
            onClick={() => {
              // Handle quote submission
              savePricingQuotaByAdmin(quoteData)
              setAdminVisibleModal(false)
            }}
          >
            Submit Quote
          </CButton>
          <CButton color="secondary" onClick={() => setAdminVisibleModal(false)}>
            Cancel
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ShowPricingQuotaModelForGame
